<div class="modal-overlay" [class.active]="isOpen" (click)="closeModal()"></div>

<div class="user-modal" [class.open]="isOpen">
  <div class="modal-header">
    <h3>Add New User</h3>
    <button data-testid="btn-close-modal" class="close-btn" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
  
  <div class="modal-content">
    <form (ngSubmit)="submitForm()" #userForm="ngForm">
      <div class="form-group">
        <label for="firstName">First Name</label>
        <input 
          type="text" 
          id="firstName"
          data-testid="input-new-user-firstname" 
          name="firstName"
          [(ngModel)]="userData.FIRST_NAME"
          required
          placeholder="Enter first name"
          [disabled]="isSubmitting"
          autofocus
        >
      </div>
      
      <div class="form-group">
        <label for="lastName">Last Name</label>
        <input 
          type="text" 
          id="lastName" 
          data-testid="input-new-user-lastname" 
          name="lastName"
          [(ngModel)]="userData.LAST_NAME"
          required
          placeholder="Enter last name"
          [disabled]="isSubmitting"
        >
      </div>
      
      <div class="form-group">
        <label for="email">Email</label>
        <input 
          type="email" 
          id="email" 
          data-testid="input-new-user-email" 
          name="email"
          [(ngModel)]="userData.EMAIL"
          required
          placeholder="Enter email address"
          [disabled]="isSubmitting"
        >
      </div>

      <!-- Organization field -->
      <div class="form-group" *ngIf="showOrganizationField">
        <label for="organization">Organization</label>

        <!-- Super admin: selectable dropdown -->
        <select
          *ngIf="inviteContext && !inviteContext.organizationLocked"
          id="organization"
          data-testid="input-new-user-organization"
          name="organization"
          [ngModel]="userData.ORGANIZATION_ID"
          (ngModelChange)="onOrganizationChange($event)"
          required
          [disabled]="isSubmitting || isLoadingContext"
        >
          <option [ngValue]="0" disabled>Select an organization</option>
          <option *ngFor="let org of organizationOptions" [ngValue]="org.value">{{ org.label }}</option>
        </select>

        <!-- Manager / Supervisor: locked read-only display -->
        <input
          *ngIf="!inviteContext || inviteContext.organizationLocked"
          type="text"
          id="organization"
          data-testid="input-new-user-organization"
          name="organization"
          [value]="inviteContext?.organizationName ?? userData.ORGANIZATION_ID"
          [disabled]="true"
          class="field-locked"
        >
        <span *ngIf="inviteContext?.organizationLocked" class="field-hint">Your organization is pre-filled and cannot be changed.</span>
      </div>

      <!-- Organization Group field -->
      <div class="form-group" *ngIf="showOrganizationGroupField">
        <label for="orgGroup">Organization Group</label>
        <input
          type="text"
          id="orgGroup"
          data-testid="input-new-user-org-group"
          name="orgGroup"
          [value]="inviteContext?.organizationGroupName ?? (userData.ORGANIZATION_GROUP_ID ? 'Group #' + userData.ORGANIZATION_GROUP_ID : 'None')"
          [disabled]="true"
          class="field-locked"
        >
        <span *ngIf="inviteContext?.organizationGroupLocked" class="field-hint">Organization group is determined automatically.</span>
      </div>

      <!-- Role selection -->
      <div class="form-group" *ngIf="showRoleSelection">
        <label for="role">User Type</label>
        <select
          id="role"
          data-testid="input-new-user-role" 
          name="role"
          [(ngModel)]="userData.ROLE"
          required
          [disabled]="isSubmitting"
        >
          <option *ngFor="let option of roleOptions" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>
      
      <div class="form-actions">
        <button type="button" data-testid="btn-cancel-modal" class="btn btn-secondary" (click)="closeModal()" [disabled]="isSubmitting">Cancel</button>
        <button type="submit" data-testid="btn-create-new-user" class="btn btn-primary" [disabled]="isSubmitting || isLoadingContext || !userData.FIRST_NAME || !userData.LAST_NAME || !userData.EMAIL">
          <span *ngIf="isSubmitting">Creating...</span>
          <span *ngIf="!isSubmitting">Create User</span>
        </button>
      </div>
    </form>
  </div>
</div>
